export class contactuspojo{
    id: number | any;
    name: string | any;
    date:string |any;
    mobileNumber: number | any;
    mailId:string | any;
    enquiryType: string | any;
    message:string | any;
    
}